import styles from './CheckoutStatusPage.scss';

import { format, parse } from 'libphonenumber-js';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkVariant } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Button } from 'src/components/Button/Button';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { useCheckout } from '../CheckoutProvider';

export const CheckoutStatusPage = () => {
  const { t } = useTranslation();
  const { emailAddress, phoneNumber } = useCheckout();

  const parsed = parse(phoneNumber, { extended: true });
  const prettyNumber = format(parsed, 'National');
  const href = format(parsed, 'RFC3966');

  return (
    <section className={styles.checkoutStatusPage}>
      <TextV2
        className={styles.checkoutStatusPageHeading}
        tagName="h2"
        variant="h2-bold"
        value={t('checkout-status-page.title')}
      />
      <TextV2
        className={styles.checkoutStatusPageDescription}
        tagName="div"
        variant="body"
        value={t('checkout-status-page.description-email', { emailAddress })}
        isMarkdown
      />
      <ul className={styles.checkoutStatusPageResendWrapper}>
        <li>
          <TextV2
            variant="body"
            value={`${t('checkout-status-page.option1')} `}
          />
          <Button
            variant={LinkVariant.TEXT}
            className={styles.checkoutStatusPageResend}
          >
            {t('checkout-status-page.resend')}
          </Button>
        </li>
        <li>
          <TextV2
            variant="body"
            value={`${t('checkout-status-page.option2')} `}
          />
          <a
            href={href}
            title={prettyNumber}
            className={styles.checkoutStatusPagePhone}
          >
            {prettyNumber}
          </a>
        </li>
      </ul>
    </section>
  );
};
